module.exports = __webpack_public_path__ + "static/media/restaurant-12.c5717db6.jpg";